import { RouteObject } from 'react-router-dom';

import Activity from '@/pages/Activity';
import Board from '@/pages/Board';
import Chart from '@/pages/Chart';
import { EmployeeByActivityPole } from '@/pages/EmployeeByActivityPole';
import { EmployeeTrainings } from '@/pages/EmployeeTrainings';
import ExtraTripsApprovalFlows from '@/pages/ExtraTripsApprovalFlows';
import ExtraTripsApprovals from '@/pages/ExtraTripsApprovals';
import FixedAllocation from '@/pages/FixedAllocation';
import { NewRegulatoryTrainingMatrixPage } from '@/pages/NewRegulatoryTrainingMatrixPage';
import ProceedingsTrainingPage from '@/pages/ProcedureTrainingPage';
import RegulatoryTrainingPage from '@/pages/RegulatoryTrainingPage';
import RequirementControlPage from '@/pages/RequirementControlPage';
import SuricattaTraining from '@/pages/SuricattaTraining';
import { SystemParameters } from '@/pages/SystemParameters';
import TrainingFiles from '@/pages/TrainingFiles';
import TrainingFileTeams from '@/pages/TrainingFileTeams';
import TrainingPlanningPage from '@/pages/TrainingPlanningPage';
import TurnstileAccess from '@/pages/TurnstileAccess';
import ViewJobTitles from '@/pages/ViewJobTitles';
import RootLayout from '../components/templates/RootLayout';
import Employees from '../pages/Employees';
import ExtraTrips from '../pages/ExtraTrips';
import Home from '../pages/Home';
import HomeData from '../pages/HomeData';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import Pendencies from '../pages/Pendencies';
import SuppliersView from '../pages/SuppliersView';
import TeamsEdit from '../pages/TeamsEdit';
import TeamsRegister from '../pages/TeamsRegister';
import TeamsRegisterPreview from '../pages/TeamsRegisterPreview';
import TrainingControlPage from '../pages/TrainingControlPage';
import ViewSchedule from '../pages/ViewSchedule';

const pages: RouteObject[] = [
	{
		path: '/',
		element: <RootLayout />,
		children: [
			{
				path: '/',
				element: <Home />,
			},
			{
				path: '/home',
				element: <HomeData />,
			},
			{
				path: '/home/planejamento-de-escalas-e-ferias',
				element: <ViewSchedule />,
			},
			{
				path: '/home/cargos-e-requisitos',
				element: <ViewJobTitles />,
			},
			{
				path: '/home/controle-de-requisitos',
				element: <RequirementControlPage />,
			},
			{
				path: '/home/visualizar-pendencias',
				element: <Pendencies />,
			},
			{
				path: '/home/colaboradores',
				element: <Employees />,
			},
			// {
			//   path: '/home/colaborador/:employeeId',
			//   element: <Employee />,
			// },
			{
				path: '/home/colaborador/:employeeId/historico-treinamentos',
				element: <EmployeeTrainings />,
			},
			{
				path: '/home/planejamento-de-escalas-e-ferias/cadastrar-estrutura-de-turma',
				element: <TeamsRegister />,
			},
			{
				path: '/home/planejamento-de-escalas-e-ferias/cadastrar-estrutura-de-turma/preview',
				element: <TeamsRegisterPreview />,
			},
			{
				path: '/home/planejamento-de-escalas-e-ferias/editar-estrutura-de-turma',
				element: <TeamsEdit />,
			},
			// {
			//   path: '/home/solicitar-realocacao',
			//   element: <AllocationRequestRegister />,
			// },
			// {
			//   path: '/home/solicitar-realocacao/:id',
			//   element: <AllocationRequestRegister />,
			// },
			// {
			//   path: '/home/realocacoes',
			//   element: <AllocationRequestHistory />,
			// },
			{
				path: '/home/matriz-treinamento-regulatorio/old',
				element: <RegulatoryTrainingPage />,
			},
			{
				path: '/home/matriz-treinamento-procedimento',
				element: <ProceedingsTrainingPage />,
			},
			{
				path: '/home/controle-treinamentos',
				element: <TrainingControlPage />,
			},
			{
				path: '/home/ficheiros/:trainingFileId/planejamento-de-turma',
				element: <TrainingPlanningPage />,
			},
			{
				path: '/home/ficheiros/:trainingFileId/planejamento-de-turma/:trainingPlanningId',
				element: <TrainingPlanningPage />,
			},
			{
				path: '/home/visualizar-fornecedores',
				element: <SuppliersView />,
			},
			{
				path: '/home/ficheiros',
				element: <TrainingFiles />,
			},
			{
				path: '/home/ficheiros/detalhamento/:id/',
				element: <TrainingFileTeams />,
			},
			{
				path: '/home/visualizar-estrutura-organograma',
				element: <Chart />,
			},
			{
				path: '/home/cadastro-alocacoes-fixas',
				element: <FixedAllocation />,
			},
			{
				path: '/home/cadastro-de-diretoria',
				element: <Board />,
			},
			{
				path: '/home/aprovar-idas-extras',
				element: <ExtraTripsApprovals />,
			},
			{
				path: '/home/fluxos-de-aprovacao/:flowId?',
				element: <ExtraTripsApprovalFlows />,
			},
			{
				path: '/home/bloqueios-catraca',
				element: <TurnstileAccess />,
			},
			{
				path: '/home/bloqueios/permissao-de-trabalho',
				element: <EmployeeByActivityPole />,
			},
			{
				path: '/home/parametros-da-catraca',
				element: <SystemParameters />,
			},
			{
				path: '/home/tipos-de-atividades',
				element: <Activity />,
			},
			{
				path: '/home/treinamentos-suricatta',
				element: <SuricattaTraining />,
			},
			{
				path: '/home/colaborador/:employeeId/idas-extras',
				element: <ExtraTrips />,
				children: [
					{
						path: ':extraTripId',
						element: <ExtraTrips />,
					},
				],
			},
			{
				path: '/home/matriz-treinamento-regulatorio/',
				element: <NewRegulatoryTrainingMatrixPage />,
			},
			{
				path: '*',
				element: <NotFound />,
			},
		],
	},
	{
		path: 'login',
		element: <Login />,
	},
];

export default pages;
